module.exports = __webpack_public_path__ + "assets/d98d872bce05132e3db361c4edf0f0c6.png";